import { accessToken } from "./sessionKey";

//@ts-ignore
import { API_ROOT, AxiosInstance } from "@careinfo/axios-service";

let instance: any;

const initInstance = async () => {
  if (!instance) {
    instance = await AxiosInstance();
  }
};

export const getApiData = async (url, param = null) => {
  await initInstance();
  let response;
  try {
    response = await instance({
      method: "GET",
      url: `${url}`,
      params: param,
      transformResponse: [
        function (responseData) {
          // Do whatever you want to transform the data
          return JSON.parse(responseData);
        },
      ],
    });
  } catch (e) {
    return e.response;
  }
  return response;
};

// Post data to API
export const postApiData = async (data) => {
  const { url, formData, setError } = data;
  await initInstance();
  let response;
  try {
    response = await instance({
      method: "POST",
      url: `${url}`,
      data: formData,
      headers: {
        Authorization: `JWT ${accessToken()}`,
      },
      transformResponse: [
        function (responseData) {
          // Do whatever you want to transform the data
          return JSON.parse(responseData);
        },
      ],
    });
  } catch (e) {
    for (const key in e.response?.data) {
      if (e.response?.data.hasOwnProperty(key)) {
        setError(key, { type: "custom", message: e.response?.data[key] });
      }
    }
    return e.response;
  }
  return response;
};

// Update data
export const patchApiData = async (data) => {
  const { url, formData, setError } = data;
  await initInstance();
  let response;
  try {
    response = await instance({
      method: "PATCH",
      url: `${url}`,
      data: formData,
      headers: {
        Authorization: `JWT ${accessToken()}`,
      },
      transformResponse: [
        function (responseData) {
          // Do whatever you want to transform the data
          return JSON.parse(responseData);
        },
      ],
    });
  } catch (e) {
    for (const key in e.response?.data) {
      if (e.response?.data.hasOwnProperty(key)) {
        setError(key, { type: "custom", message: e.response?.data[key] });
      }
    }
    return e.response;
  }
  return response;
};

export const postApiFormData = async (data: {
  url: string;
  formData: FormData;
  setError?: any;
}) => {
  await initInstance();
  const { url, formData, setError } = data;
  let response: any;
  try {
    response = await instance({
      method: "POST",
      url: `${url}`,
      data: formData,
      headers: {
        "Content-Type": `multipart/form-data`,
      },
      transformResponse: [
        function (responseData: any) {
          try {
            return JSON.parse(responseData);
          } catch (e) {
            throw new setError(e.message);
          }
        },
      ],
    });
  } catch (e: any) {
    for (const key in e.response?.data) {
      if (e.response?.data.hasOwnProperty(key) && setError) {
        setError(key as any, {
          type: "custom",
          message: e.response?.data[key],
        });
      }
    }
    return e.response;
  }
  return response;
};

// create form data to upload files
export const patchApiFormData = async (data: any) => {
  const { url, formData, setError } = data;
  let response;
  await initInstance();
  try {
    response = await instance({
      method: "PATCH",
      url: `${url}`,
      data: formData,
      headers: {
        "Content-Type": `multipart/form-data`,
      },
      transformResponse: [
        function (responseData: any) {
          //Do whatever you want to transform the data
          return JSON.parse(responseData);
        },
      ],
    });
  } catch (e: any) {
    for (const key in e.response?.data) {
      if (e.response?.data.hasOwnProperty(key) && setError) {
        setError(key, { type: "custom", message: e.response?.data[key] });
      }
    }
    return e.response;
  }
  return response;
};

export const deleteApiData = async (data) => {
  const { url, setError } = data;
  await initInstance();
  let response;

  try {
    response = await instance({
      method: "DELETE",
      url: `${url}`,
      headers: {
        Authorization: `JWT ${accessToken()}`,
      },
      // Only transform response if there is content
      transformResponse: [
        function (responseData) {
          if (!responseData) return null; // for 204 No Content
          return JSON.parse(responseData);
        },
      ],
    });
  } catch (e) {
    // Handle errors from the server
    if (e.response?.data && typeof e.response.data === "object") {
      for (const key in e.response.data) {
        if (Object.prototype.hasOwnProperty.call(e.response.data, key)) {
          setError(key, { type: "custom", message: e.response.data[key] });
        }
      }
    } else {
      console.error("Unexpected error format:", e);
    }
    return e.response;
  }

  return response?.status === 204 ? { status: 204, data: null } : response;
};

export { API_ROOT };
